import { AxiosResponse } from "axios";
import { API_ROUTE } from "../const/apiRoute";
import { HanderResponse } from "../_base/helper/FunctionHelper";
import { api } from "../library/axios";
import { isNullOrUndefined } from "../_base/extension/StringExtension";
import { NotificationExtension } from "../_base/extension/NotificationExtension";

export const getListBrandCategory = async (query: string): Promise<any> => {
  try {
    const response: AxiosResponse = await api.get(
      `${API_ROUTE.GET_LIST_BRAND_CATEGORY}?${query}`
    );
    return response.data;
  } catch (error) {
    HanderResponse(error);
  }
};

export const createBrandCategory = async (data: any): Promise<any> => {
  try {
    const response: AxiosResponse = await api.post(
      `${API_ROUTE.CREATE_BRAND_CATEGORY}`,
      data
    );
    if (!isNullOrUndefined(response) && response?.data?.success) {
      NotificationExtension.Success("Thêm mới thành công !");
    } else if (response != null) {
      NotificationExtension.Fails("Thêm mới thất bại !");
    }
    return response.data;
  } catch (error) {
    HanderResponse(error);
  }
};

export const modifyBrandCategory = async (data: any): Promise<any> => {
  try {
    const response: AxiosResponse = await api.post(
      `${API_ROUTE.MODIFY_BRAND_CATEGORY}`,
      data
    );
    if (!isNullOrUndefined(response) && response?.data?.success) {
      NotificationExtension.Success("Chỉnh sửa thành công !");
    } else if (response != null) {
      NotificationExtension.Fails("Chỉnh sửa thất bại !");
    }
    return response.data;
  } catch (error) {
    HanderResponse(error);
  }
};

export const deleteBrandCategory = async (data: any): Promise<any> => {
  try {
    const response: AxiosResponse = await api.post(
      `${API_ROUTE.DELETE_BRAND_CATEGORY}`,
      data
    );
    if (!isNullOrUndefined(response) && response?.data?.success) {
      NotificationExtension.Success("Xoá thành công !");
    } else if (response != null) {
      NotificationExtension.Fails("Xoá thất bại !");
    }
    return response.data;
  } catch (error) {
    HanderResponse(error);
  }
};

export const getDetailBrandCategory = async (id: number): Promise<any> => {
  try {
    const response: AxiosResponse = await api.post(
      `${API_ROUTE.GET_DETAIL_BRAND_CATEGORY}?id=${id}`
    );
    return response.data;
  } catch (error) {
    HanderResponse(error);
  }
};

export const importBrandCategory = async (data: any): Promise<any> => {
  try {
    const response: AxiosResponse = await api.post(
      API_ROUTE.IMPORT_BRAND_CATEGORY,
      data,
      {
        headers: { "Content-Type": "multipart/form-data" },
      }
    );
    if (
      !isNullOrUndefined(response) &&
      (response?.data?.success ||
        (response?.data?.data && response?.data?.data?.failedRows === 0))
    ) {
      NotificationExtension.Success(response?.data?.message || "Import thành công !");
    } else if (response != null) {
      NotificationExtension.Fails(response?.data?.message || "Import thất bại !");
    }
    return response.data;
  } catch (error) {
    HanderResponse(error);
  }
};

